import { Entity } from "./entity";

export let percFromGruppo = (gruppo: number) => {
  switch (gruppo) {
    case 1:
    case 2:
    case 3:
    case 7:
      return 40;
    case 4:
      return 54;
    case 5:
      return 86;
    case 6:
      return 62;
    case 8:
      return 78;
    case 9:
      return 67;
  }
  return 40;
}

export class AgencyState {
  public static Active = 'A';
  public static Disabled = 'D';
  public static Suspended = 'S';
}

export class NomiOggetti {
  key: string;
  label: string;
  cell: string;
  statekey: string;
  formulaExcel: string;
  formulaJs: string;
  tooltip: string;
}

export class TabelleAnnuali {
  tipo: string;
  fino_a_1: number;
  fino_a_2: number;
  fino_a_3: number;
  fino_a_4: number;
  fino_a_oltre: number;
  perc_1: number;
  perc_2: number;
  perc_3: number;
  perc_4: number;
  perc_5: number;
  max_1: number;
  max_2: number;
  max_3: number;
  max_4: number;
  oltre_1: number;
  oltre_2: number;
  oltre_3: number;
  oltre_4: number;
  eccede_1: number;
  eccede_2: number;
  eccede_3: number;
  eccede_4: number;
}

//Generic to get result from api
export class Result<T extends Entity> {
  ResultList: T[];
  ListLength: number;
}
